if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

        if (navigator.share) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', () => {
            navigator.share({ url: this.urlToShare, title: document.title });
          });
        } else {
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
          this.mainDetailsToggle
            .querySelector('.share-button__copy')
            .addEventListener('click', this.copyToClipboard.bind(this));
          this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));
        }
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }

      copyToClipboard() {
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        });
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }
    }
  );
}

if (!customElements.get('arelana-product-share')) {
  customElements.define('arelana-product-share', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.input = this.querySelector('[data-share-url]');
      this.panel = this.querySelector('[data-share-fallback]');
      this.status = this.querySelector('[data-share-status]');
      this.more = this.querySelector('[data-share-more]');
      this.updateUrl(this.dataset.url);
      this.querySelector('[data-share-copy]').addEventListener('click', async () => {
        this.status.textContent = '';
        try {
          await navigator.clipboard.writeText(this.urlToShare);
          this.status.textContent = this.dataset.copied;
        } catch (error) {
          this.panel.hidden = false;
          this.more.setAttribute('aria-expanded', 'true');
          this.input.focus();
          this.input.select();
          this.status.textContent = this.dataset.manual;
        }
      });
      this.more.addEventListener('click', async () => {
        this.status.textContent = '';
        if (navigator.share) {
          try {
            await navigator.share({title: this.dataset.title, url: this.urlToShare});
            return;
          } catch (error) {
            if (error.name === 'AbortError') return;
          }
        }
        this.panel.hidden = !this.panel.hidden;
        this.more.setAttribute('aria-expanded', String(!this.panel.hidden));
      });
    }
    updateUrl(url) {
      this.urlToShare = new URL(url || location.href, location.origin).href;
      if (!this.input) return;
      this.input.value = this.urlToShare;
      this.querySelector('[data-share-whatsapp]').href = 'https://wa.me/?text=' + encodeURIComponent(this.dataset.title + '\n' + this.urlToShare);
      this.querySelector('[data-share-email]').href = 'mailto:?subject=' + encodeURIComponent(this.dataset.title) + '&body=' + encodeURIComponent(this.urlToShare);
    }
  });
}
